import { render, staticRenderFns } from "./SideMenuModal.vue?vue&type=template&id=1ee2c728&scoped=true"
import script from "./SideMenuModal.vue?vue&type=script&lang=js"
export * from "./SideMenuModal.vue?vue&type=script&lang=js"
import style0 from "./SideMenuModal.vue?vue&type=style&index=0&id=1ee2c728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee2c728",
  null
  
)

export default component.exports